import { Box, Collapse, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { useRef, useState } from "react";
import DOMPurify from 'dompurify';
import img_icon from "../../Assets/svgs/img_icon.svg"
import removeIcon from "../../Assets/svgs/minus-3108.svg"
import addIcon from "../../Assets/svgs/red-plus-11961.svg"
import downloadIcon from "../../Assets/svgs/download-arrow-4178.svg"
import { highlightPatterns } from "../../Common/Util";

const RenderSummary = ({rawText,useRef}:any) => {

    const [expanded, setExpanded] = useState<Record<string, boolean>>({});
    const [previewGallery, setPreviewGallery] = useState<string[]>([]);
    const [galleryTitle, setGalleryTitle] = useState<string>('');
    const [selectedImage, setSelectedImage] = useState<{ src: string; name: string } | null>(null);

    const handleToggle = (header: string) => {
      setExpanded((prev) => ({ ...prev, [header]: !prev[header] }));
    };

    const openGallery = (sectionName: string) => {
      const sectionImages = rawText.images.find((img:any) => img.section_name.trim().toLowerCase() === sectionName.toLowerCase());
      if (sectionImages) {
        setGalleryTitle(sectionName);
        setPreviewGallery(sectionImages.image);
      }
  };

    const renderContent = () => {
      const regex = /-- \*\*(.*?)\*\*\s*<hide>((?:.|\n)*?)<\/hide>/g;
      const result: React.ReactNode[] = [];

      let lastIndex = 0;
      let match: RegExpExecArray | null;
      let text = rawText.chatMessage;

      while ((match = regex.exec(text)) !== null) {
        const [fullMatch, header, hiddenContent] = match;
        const matchIndex = match.index;

        if (matchIndex > lastIndex) {
          const interText = text.slice(lastIndex, matchIndex);
          result.push(...renderImages(interText));
        }

        result.push(
          <div key={header} >
          <ul style={{marginBottom:0,paddingBottom:0}}>
            <li style={{margin:0,padding:0}}>
              <Typography variant="subtitle1" sx={{ mr: 1, fontSize: 12 }}>
                  <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highlightPatterns(header)) }} className='mt3' style={{fontWeight: 900}}/>
                  &nbsp;
                  {expanded[header] ? <img src={removeIcon} style={{height:"8px",width:"8px", cursor:"pointer"}} onClick={() => handleToggle(header)}/> : <img src={addIcon} style={{height:"8px",width:"8px", cursor:"pointer"}} onClick={() => handleToggle(header)}  />}
              </Typography>            
            <Collapse in={!!expanded[header]}>
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highlightPatterns(hiddenContent.trim())) }} className='mt3' style={{marginLeft:"10px"}}/>
            </Collapse>
          </li>
          </ul>
        </div>
        );

        lastIndex = matchIndex + fullMatch.length;
      }

      if (lastIndex < text.length) {
        const remaining = text.slice(lastIndex);
        result.push(...renderImages(remaining));
      }

      return result;
    };

    const renderImages = (text: string): React.ReactNode[] => {
      const parts = text.split(/<image>(.*?)<\/image>/g);
      const output: React.ReactNode[] = [];

      parts.forEach((part, index) => {
        if (index % 2 === 1) {
           output.push(
            <IconButton
              key={`img-${index}`}
              size="small"
              onClick={() => openGallery(part.trim())}
              title={`Show image: ${part.trim()}`}
            >
              <img src={img_icon} style={{height:"20px",width:"20px"}}/>
            </IconButton>
          );
        } else {
          part.split("\n").map((item: any, idx: number) => {
                          output.push (
                              <span key={idx}>
                                  {item !== "" && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highlightPatterns(item)) }} className='mt3' />}
                              </span>
                          )
                      })
        }
      });

      return output;
    };

  return (
    <>
      <h5 style={{textDecoration:"underline"}}>UAE MT Insights Summary</h5>
      {renderContent()}

      {/* <Dialog open={!!openImage} onClose={() => setOpenImage(null)} maxWidth="md">
        <Box onClick={() => setOpenImage(null)} sx={{ cursor: 'pointer' }}>
          <img src={openImage ?? ''} alt="Preview" style={{ maxWidth: '100%' }} />
        </Box>
      </Dialog> */}

      <Dialog open={previewGallery.length > 0} onClose={() => setPreviewGallery([])} maxWidth="md">
        <DialogTitle>{galleryTitle}</DialogTitle>
        <DialogContent>
          <Box display="flex" flexWrap="wrap" gap={2}>
            {previewGallery.map((img, idx) => (
              <>
              <Box
                key={`${galleryTitle}-${idx}`}
                sx={{ cursor: 'pointer', border: '1px solid #ccc', p: 1 }}
                onClick={() => setSelectedImage({ src: img, name: `${galleryTitle}_${idx}.png` })}
              >
                <img
                  src={`data:image/png;base64,${img}`}
                  alt={`${galleryTitle}-${idx}`}
                  style={{ width: 100, height: 100, objectFit: 'contain' }}
                />
              </Box>
              </>
            ))}
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={!!selectedImage} onClose={() => setSelectedImage(null)} maxWidth="md">
        <DialogTitle>
          {selectedImage?.name}
          <IconButton
            onClick={() => {
              const a = document.createElement('a');
              a.href = `data:image/png;base64,${selectedImage?.src}` || '';
              a.download = selectedImage?.name || 'download.png';
              a.click();
            }}
            sx={{ ml: 2 }}
          >
            <img src={downloadIcon} style={{ width: "20px", height: "20px", objectFit: 'contain' }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedImage && (
            <img
              src={`data:image/png;base64,${selectedImage.src}`}
              alt={selectedImage.name}
              style={{ maxWidth: '100%', maxHeight: '80vh' }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default RenderSummary;